import { render } from "./FormRadioField.vue?vue&type=template&id=1ac9b94f&scoped=true"
import script from "./FormRadioField.vue?vue&type=script&lang=js"
export * from "./FormRadioField.vue?vue&type=script&lang=js"

import "./FormRadioField.vue?vue&type=style&index=0&id=1ac9b94f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac9b94f"]])

export default __exports__